import { GeneralUserDashboardSidebarActions } from "../../../components/RefactoredDashboard/DesktopSidebarActions";
import DashboardMiniDisplay from "../../../components/RefactoredDashboard/ParticipantDashboard/DashboardMiniDisplay";
import { ImprovedParticipantDashboard } from "../../../Interfaces/FundraiserRole";
import "./DesktopDashboard.css";
import DesktopSidebar from "../../../components/RefactoredDashboard/DesktopSidebar";
import { LoggedInAccount } from "../../../Interfaces/AccountUsers";
import GoalProgressDisplay from "../../../components/RefactoredDashboard/ParticipantDashboard/GoalProgressDisplay";
import MyStoreDisplay from "../../../components/RefactoredDashboard/ParticipantDashboard/MyStoreDisplay";
import ShareStreak from "../../../components/RefactoredDashboard/ParticipantDashboard/ShareStreak";
import Leaderboard from "../../../components/RefactoredDashboard/ParticipantDashboard/Leaderboard";
import { parseParticipantID } from "../../../CommonFunctions";
import OrderDisplay from "../../../components/RefactoredDashboard/ParticipantDashboard/OrderDisplay";
import BuyoutComponent from "../../../pages/Dashboards/Participant/Buyout";
interface ParticipantDashboardDesktopViewProps {
  participantDashboard: ImprovedParticipantDashboard;
  loggedInUser: LoggedInAccount | null;
  isMobile: boolean;
}

const ParticipantDashboardDesktopView: React.FC<
  ParticipantDashboardDesktopViewProps
> = ({ participantDashboard, loggedInUser, isMobile }) => {
  const calculateNearestFivePercent = (
    participant_rank: number,
    total_participants: number,
  ) => {
    if (total_participants === 0) return 0;
    const percentage = (participant_rank / total_participants) * 100;

    // Round to the up nearest 5% -> top 5%,top 10%, top 15%, ETC
    const roundedPercentage = Math.ceil(percentage / 5) * 5;
    return roundedPercentage;
  };
  console.log(participantDashboard);

  return (
    <div className="general-dashboard-desktop-view">
      {!isMobile && (
        <div className="general-dashboard-sidebar-content">
          <DesktopSidebar
            profileName={
              loggedInUser
                ? `${loggedInUser.first_name} ${loggedInUser.last_name}`
                : "first Name" + " " + "Last Name"
            }
            actions={GeneralUserDashboardSidebarActions}
          />
        </div>
      )}
      <div className="general-dashboard-content-wrapper">
        <div className="general-dashboard-mini-display-container">
          <DashboardMiniDisplay
            topLeftText="Total Raised:"
            topRightText={`${((participantDashboard.goal_status.total_profit / participantDashboard.goal_status.goal) * 100).toFixed(2)}% of goal`}
            mainText={`$${participantDashboard.goal_status.total_profit.toFixed(2)}`}
            subText={`Goal: $${participantDashboard.goal_status.goal.toFixed(2)}`}
            progressPercentage={
              (participantDashboard.goal_status.total_profit /
                participantDashboard.goal_status.goal) *
              100
            }
          />
          <DashboardMiniDisplay
            topLeftText="Orders"
            topRightText={`${participantDashboard.participant_orders.transactions_this_week} this week`}
            mainText={`${participantDashboard.participant_orders.total_transactions}`}
            subText="from your store"
          />
          <DashboardMiniDisplay
            topLeftText="Your Rank"
            topRightText={`Top ${calculateNearestFivePercent(
              participantDashboard.ranking.position,
              participantDashboard.ranking.total_participants,
            )}%`}
            mainText={`#${participantDashboard.ranking.position}`}
            subText={`of ${participantDashboard.ranking.total_participants} participants`}
            progressPercentage={
              100 -
              calculateNearestFivePercent(
                participantDashboard.ranking.position,
                participantDashboard.ranking.total_participants,
              ) // fill the bar inversely to the rank, so higher rank means more filled bar
            }
          />
        </div>

        <div className="participant-dashboard-row">
          <GoalProgressDisplay
            raised={participantDashboard.goal_status.total_profit}
            goal={participantDashboard.goal_status.goal}
          />
          <MyStoreDisplay
            fundraiserInfo={participantDashboard.fundraiser_info}
          />
        </div>
        <div className="participant-dashboard-row">
          <ShareStreak streak={participantDashboard.share_streak} />
          <Leaderboard
            ranking={participantDashboard.ranking}
            currentParticipantID={parseParticipantID(
              participantDashboard.fundraiser_info.participant_code,
            )}
          />
        </div>
        {participantDashboard.goal_status.original_buyout !== 0 && (
          <div className="participant-dashboard-row participant-dashboard-row--centered">
            <BuyoutComponent
              originalBuyout={participantDashboard.goal_status.original_buyout}
              profitEarnedSoFar={participantDashboard.goal_status.total_profit}
              hasBoughtout={participantDashboard.goal_status.has_boughtout}
              fundraiserEndDate={participantDashboard.fundraiser_info.end_date}
              participantID={parseParticipantID(
                participantDashboard.fundraiser_info.participant_code,
              )}
            />
          </div>
        )}
        <OrderDisplay
          participant_orders={participantDashboard.participant_orders}
        />
      </div>
    </div>
  );
};

export default ParticipantDashboardDesktopView;
